import { useNavigate } from 'react-router-dom';
import './index.scss';

const Button = (props) => {
  const { children, to } = props;
  const navigate = useNavigate();
    
  return (
    <button type="button" className="star-btn btn" onClick={() => navigate(to || '/login')}>
      <strong>{children}</strong>
      <div id="container-stars">
        <div id="stars"></div>
      </div>

      <div id="glow">
        <div className="circle"></div>
        <div className="circle"></div>
      </div>
    </button>

  );
};

export default Button;
